// src/pages/AdminLogin/AdminLogin.jsx
import React, { useState, useContext } from "react";
import axios from "axios";
import "./AdminLogin.css";
import { AuthContext } from "../../context/AuthContext";
import { COPY, useToast } from "../../context/ToastContext";
import { useNavigate } from "react-router-dom";

function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { setAuthState } = useContext(AuthContext);
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `/api/admin?action=login`,
        { username, password },
        { withCredentials: true }
      );
      setAuthState({ isAuthenticated: true, role: "admin", user: response.data.user });
      toast.success("Welcome back! You're signed in.");
      navigate("/");
    } catch (error) {
      // The unreachable-server case has to be checked first: with no response
      // there is no status to branch on, and blaming the password would be wrong.
      if (!error.response) {
        toast.error(COPY.unreachable);
      } else if (error.response.status === 401 || error.response.status === 400) {
        // The API answers 401 for both an unknown username and a bad password,
        // so one message covers them without confirming which accounts exist.
        toast.error("That username or password didn't match. Give it another try.");
      } else if (error.response.status === 429) {
        toast.warning(COPY.rateLimited);
      } else {
        toast.error(COPY.serverError);
      }
      setPassword("");
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-container">
        <h1 className="admin-login-title">Admin Login</h1>
        <form className="admin-login-form" onSubmit={handleLogin}>
          <div className="input-group">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoComplete="off"
            />
          </div>
          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="off"
            />
          </div>
          <button className="submit-btn" type="submit">
            Login
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;
